import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
export function LoginPage() {
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as {
    from?: {
      pathname: string;
    };
  })?.from?.pathname || '/';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate(from, {
        replace: true
      });
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-background flex items-center justify-center p-4" data-id="element-366">
      <div className="w-full max-w-md bg-card border border-border rounded-lg shadow-sm p-8" data-id="element-367">
        <div className="text-center mb-8" data-id="element-368">
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/pzhmlekvyppnluh27wy1t9/f3160bd3-c8c6-4ee6-97ae-1dc6fc5bb54a/logo.png" alt="Lawvo" className="h-10 mx-auto mb-4" data-id="element-369" />
          <h1 className="text-2xl font-bold text-foreground" data-id="element-370">Group Setup Request</h1>
          <p className="text-sm text-muted-foreground mt-2" data-id="element-371">
            Sign in with your LawVo super-admin account to continue.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-372">
          <div data-id="element-373">
            <label htmlFor="email" className="block text-sm font-medium text-foreground mb-1" data-id="element-374">
              Email
            </label>
            <input id="email" type="email" required autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring" data-id="element-375" />
          </div>
          <div data-id="element-376">
            <label htmlFor="password" className="block text-sm font-medium text-foreground mb-1" data-id="element-377">
              Password
            </label>
            <input id="password" type="password" required autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring" data-id="element-378" />
          </div>

          {error && <p className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2" data-id="element-379">
              {error}
            </p>}

          <button type="submit" disabled={isSubmitting} className="w-full py-2.5 bg-violet-blue text-white rounded-md text-sm font-medium hover:bg-violet-blue/90 disabled:opacity-60" data-id="element-380">
            {isSubmitting ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>;
}